import {
  addNameWithCommaFormatter,
  calculateAge,
  middleNameFormatter,
  textFormatter,
} from "components/Formatter";
import { ImageElement } from "components/UiElement";
import { DateFormatess } from "helpers";
import ReportCategory from "pages/User/ReportCategory/index.page";
import { useState } from "react";
import { Container } from "react-bootstrap";
import { Link } from "react-router-dom";
import {
  checkValidData,
  commasFormatter,
  dayJsDateFormatter,
  getLocation,
} from "utils";

function AboutSection({ memorialData, role, id, isModal }) {
  const [showReportModal, setReportModal] = useState(false);
  return (
    <>
      {" "}
      <Container>
        <div className="d-md-flex">
          <div className="aboutSec_left w-100 flex-shrink-0">
            <ImageElement
              previewSource={memorialData?.themeOnes?.[0]?.profileImageUrl}
              className="img-fluid d-block"
              alt="about-image"
            />
            <div className="aboutSec_left_inner">
              <div className="aboutSec_subTitle mb-0 text-center text-md-start">
                About
              </div>
              <ul className="list-unstyled mb-0">
                {memorialData?.birthDate && (
                  <li className="d-flex">
                    <span className="flex-shrink-0">Born:</span>{" "}
                    {dayJsDateFormatter(memorialData?.birthDate, DateFormatess)}
                    {` ( age ${calculateAge(
                      memorialData?.birthDate,
                      memorialData?.deathDate
                    )} Years )`}
                  </li>
                )}
                {memorialData?.birthState?.name && (
                  <li className="d-flex">
                    <span className="flex-shrink-0">Birth Place:</span>
                    {addNameWithCommaFormatter(
                      textFormatter(memorialData?.birthState?.name),

                      textFormatter(memorialData?.birthCountry?.name)
                    )}
                  </li>
                )}
                {memorialData?.spouse?.fullName && (
                  <li className="d-flex text-break">
                    <span className="flex-shrink-0">Spouse: </span>
                    {checkValidData(
                      textFormatter(memorialData?.spouse?.fullName)
                    )}
                  </li>
                )}
                {memorialData?.children?.length > 0 && (
                  <li className="d-flex text-break">
                    <span className="flex-shrink-0">Children:</span>
                    {commasFormatter(
                      memorialData?.children?.map((item) =>
                        textFormatter(item?.fullName)
                      )
                    )}
                  </li>
                )}
                {(memorialData?.father?.fullName ||
                  memorialData?.mother?.fullName) && (
                  <li className="d-flex text-break">
                    <span className="flex-shrink-0">Parents:</span>
                    {addNameWithCommaFormatter(
                      textFormatter(memorialData?.father?.fullName),
                      textFormatter(memorialData?.mother?.fullName)
                    )}
                  </li>
                )}
                {memorialData?.siblings?.length > 0 && (
                  <li className="d-flex text-break">
                    <span className="flex-shrink-0">Siblings:</span>
                    {commasFormatter(
                      memorialData?.siblings?.map((item) =>
                        textFormatter(item?.fullName)
                      )
                    )}
                  </li>
                )}
              </ul>
            </div>
          </div>
          <div className="aboutSec_right">
            <div className="aboutSec_right_head text-break">
              <h1 className="aboutSec_title text-white mb-2">
                {checkValidData(
                  textFormatter(
                    middleNameFormatter(
                      memorialData?.firstName,
                      memorialData?.middleName,
                      memorialData?.lastName
                    )
                  )
                )}
              </h1>
              <div className="txt">
                {dayJsDateFormatter(memorialData?.birthDate, DateFormatess)}{" "}
                {memorialData?.deathDate &&
                  `- ${dayJsDateFormatter(
                    memorialData?.deathDate,
                    DateFormatess
                  )}`}
              </div>
              {memorialData?.location && (
                <span className="d-flex txt">
                  <em className="icon-location" />
                  {getLocation(memorialData?.location)}
                </span>
              )}
              {/* Social Icons */}
              <div className="d-flex justify-content-between align-items-end">
                <ul className="list-inline mb-0 aboutSec_social flex-shrink-0">
                  {memorialData?.instagram && (
                    <li className="list-inline-item">
                      <Link
                        aria-label="instagram"
                        target="_blank"
                        to={memorialData?.instagram}
                        className="d-flex align-items-center justify-content-center aboutSec_social_icon"
                      >
                        <em className="icon-instagram" />
                      </Link>
                    </li>
                  )}
                  {memorialData?.twitter && (
                    <li className="list-inline-item">
                      <Link
                        aria-label="twitter"
                        target="_blank"
                        to={memorialData?.twitter}
                        className="d-flex align-items-center justify-content-center aboutSec_social_icon"
                      >
                        <em className="icon-twitter" />
                      </Link>
                    </li>
                  )}
                  {memorialData?.facebook && (
                    <li className="list-inline-item">
                      <Link
                        aria-label="facebook"
                        target="_blank"
                        to={memorialData?.facebook}
                        className="d-flex align-items-center justify-content-center aboutSec_social_icon"
                      >
                        <em className="icon-facebook" />
                      </Link>
                    </li>
                  )}
                  {role === "user" && !isModal && (
                    <li className="list-inline-item">
                      <Link
                        aria-label="report"
                        to="#"
                        className="d-flex align-items-center justify-content-center aboutSec_social_icon"
                        onClick={(e) => {
                          e.preventDefault();
                          setReportModal(true);
                        }}
                      >
                        <em className="icon-report" />
                      </Link>
                    </li>
                  )}
                </ul>

                {/* <RippleEffect
                  extraClassName="justify-content-end"
                >
                  <Button className="btn btn-sm btnDownload">
                    <em className="icon-download me-sm-2" />
                    <span className="d-none d-sm-block">Download</span>
                  </Button>
                </RippleEffect> */}
              </div>
            </div>
            <div className="aboutSec_right_body">
              <h2 className="aboutSec_subTitle mb-0">Biography</h2>
              <p className="mb-0 text-break">{memorialData?.myBio}</p>
            </div>
          </div>
        </div>
      </Container>{" "}
      {/* Report modal */}
      {showReportModal && (
        <ReportCategory
          setReportModal={setReportModal}
          showReportModal={showReportModal}
          id={id}
        />
      )}
    </>
  );
}

export default AboutSection;
